import { render, staticRenderFns } from "./solutionDSJFX.vue?vue&type=template&id=511771b8&scoped=true"
import script from "./solutionDSJFX.vue?vue&type=script&lang=js"
export * from "./solutionDSJFX.vue?vue&type=script&lang=js"
import style0 from "./solutionDSJFX.vue?vue&type=style&index=0&id=511771b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "511771b8",
  null
  
)

export default component.exports